export default __webpack_public_path__ + "static/media/softwaredevelopment.5d45eeef.png";